// Mirrors aws-lambda/shared/validate.mjs -> HOME_LOCATIONS. Keep both in sync.
export const HOME_LOCATIONS = [
  { id: "bay_area", label: "Bay Area" },
  { id: "sacramento", label: "Sacramento" },
  { id: "tahoe_local", label: "Tahoe local" },
];

export const HOME_LOCATION_LABELS = Object.fromEntries(HOME_LOCATIONS.map((l) => [l.id, l.label]));
